import React from "react";
import { map, get } from "lodash";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import cx from "classnames";
import Icon from "@components/common/Icon";
import styles from "./TableContent.module.scss";
import { useTheme } from "next-themes";

const View = ({ data }: any) => {
  const { scroll } = useLocomotiveContext();
  const { theme } = useTheme();
  const [collapse, $collapse] = React.useState(false);
  const handle = {
    onClick: (e: any) => {
      const to = get(e, "target.dataset.className");
      const element = document.querySelector(`.${to}`);
      if (!!to) {
        scroll.scrollTo(element, { offset: -84, duration: 200 });
      }
    },
    toggle: () => {
      $collapse(!collapse);
    },
  };
  return (
    <div className={styles.section}>
      <div
        className={cx(styles.action, { [styles.flip]: collapse })}
        onClick={handle.toggle}
      >
        <Icon
          size={28}
          className={cx(styles.arrow)}
          style={{ padding: "0.25rem" }}
          name="chevron-right-outline"
          color={cx({ "#000": theme === "light", "#fff": theme === "dark" })}
          alt="button right"
        />
        <label>Mục Lục</label>
      </div>
      <div className={cx(styles.table, { [styles.collapse]: collapse })}>
        {map(
          data,
          (item, index) =>
            !!get(item, "titleTableOfContent") && (
              <h6
                key={`toc_${index}`}
                data-class-name={get(item, "className")}
                onClick={handle.onClick}
              >
                {get(item, "titleTableOfContent")}
              </h6>
            )
        )}
      </div>
    </div>
  );
};
export default View;
